import { render, staticRenderFns } from "./LeadershipGroup.vue?vue&type=template&id=4a151b90"
import script from "./LeadershipGroup.vue?vue&type=script&lang=js"
export * from "./LeadershipGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports